import { ParsedQs } from 'qs';

export interface IPaginationQuery {
  pageNumber?: number;
  pageSize?: number;
}

export interface IConvertPaginationQueryStringToPaginationQueryProps {
  pageNumber?: string | string[] | ParsedQs | ParsedQs[];
  pageSize?: string | string[] | ParsedQs | ParsedQs[];
}

export const convertPaginationQueryStringToPaginationQuery = (
  { pageNumber, pageSize }: IConvertPaginationQueryStringToPaginationQueryProps,
  defaults: IPaginationQuery = { pageNumber: undefined, pageSize: undefined }
): Partial<IPaginationQuery> => ({
  pageNumber: typeof pageNumber === 'string' && parseInt(pageNumber) ? parseInt(pageNumber) : defaults.pageNumber,
  pageSize: typeof pageSize === 'string' && parseInt(pageSize) ? parseInt(pageSize) : defaults.pageSize,
});

export const defaultPagination: IPaginationQuery = {
  pageSize: 25,
  pageNumber: 1,
};
